

import React, { Component } from 'react';
import classNames from 'classnames';
import get from 'lodash/get';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import AppButton from 'src/components/common/app-button';
import MapImageContainer from 'src/components/common/map-image-container';
import HelpPopoverIcon from 'src/components/theme/help-popover-icon';
import TopBar from 'src/components/theme/top-bar';
import TopBarButtons from 'src/components/theme/top-bar-buttons';

const clsPrefix = 'public-share-container';

@inject('ui', 'account')
@observer
export default class PublicShareContainer extends Component {
  static propTypes = {
    ui: PropTypes.object.isRequired,
    account: PropTypes.object.isRequired,
    heroContent: PropTypes.object,
    address: PropTypes.object,
    children: PropTypes.any,
    className: PropTypes.string,
    showAddress: PropTypes.bool,
    showTopBar: PropTypes.bool,
    signUpDetails: PropTypes.object,
    theme: PropTypes.object,
    isCompass: PropTypes.bool,
  };

  static defaultProps = {
    showAddress: true,
    showTopBar: true,
  };

  render() {
    const {
      ui,
      account,
      children,
      className,
      address,
      heroContent,
      showAddress,
      showTopBar,
      theme,
      signUpDetails,
      isCompass,
    } = this.props;
    const customImageUrl = get(heroContent, 'customImageUrl', '');

    let signUpButton = null;

    if (signUpDetails && !isCompass) {
      if (signUpDetails.isRegistered) {
        signUpButton = (
          <AppButton
            type="primary"
            href={`/auth/login/?next=${encodeURIComponent(
              window.location.href
            )}&email=${encodeURIComponent(signUpDetails.email)}`}
          >
            {signUpDetails.firstName && !ui.isMobileSize
              ? `Login as ${signUpDetails.firstName}`
              : 'Login'}
          </AppButton>
        );
      } else {
        signUpButton = (
          <AppButton
            href="/auth/register/?code=share"
            type="secondary"
            className={`${clsPrefix}__sign-up`}
          >
            Create Free Account
          </AppButton>
        );
      }
    }

    return (
      <React.Fragment>
        {showTopBar ? (
          <TopBar
            homeRouteName="quitPublicApp"
            showLogo
            purpleLogo
            theme={theme}
            isCompass={isCompass}
          >
            <TopBarButtons light={!!theme}>
              {account.isAuthenticated ? (
                <React.Fragment>
                  {!ui.isMobileSize && (
                    <TopBarButtons.LinkButton routeName="quitPublicApp">
                      Home
                    </TopBarButtons.LinkButton>
                  )}
                  {!ui.isMobileSize && <TopBarButtons.Divider />}
                  {!ui.isMobileSize && <HelpPopoverIcon />}
                  <TopBarButtons.DropdownAvatar />
                </React.Fragment>
              ) : (
                signUpButton
              )}
            </TopBarButtons>
          </TopBar>
        ) : null}
        <div
          className={classNames(clsPrefix, className, {
            [`${clsPrefix}--has-custom-image`]: !!customImageUrl,
          })}
        >
          <div className={`${clsPrefix}__section-container`}>
            <div className={`${clsPrefix}__section-title`}>
              {showAddress && (
                <div>
                  <h1 className={`white-text ${clsPrefix}__title`}>
                    {address.street} {address.unit}
                  </h1>
                  <h2 className={`white-text uppercase ${clsPrefix}__subtitle`}>
                    {address.city}, {address.state} {address.zipCode}
                  </h2>
                </div>
              )}
            </div>
            <div className={`${clsPrefix}__section-row`}>
              <div className={`${clsPrefix}__section-row-inset`}>
                {children}
              </div>
            </div>
          </div>
          {customImageUrl ? (
            <img
              className={`${clsPrefix}__bkg-container-image2`}
              src={customImageUrl}
              alt=""
            />
          ) : (
            <MapImageContainer
              address={address}
              className={`${clsPrefix}__bkg-container-image2`}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}
